module.exports = __webpack_public_path__ + "f4fdb089ff8fb3f557c67c84cd2a5914.png";